import { status } from "skin/event/status";
import { generateCode } from "./generate-code";

export default function promoMasterReducer(obj, ms, story, data, d, action) {
	if (obj.code === "generateCode") data.setValue("value", generateCode());

	return status.action;
}
